import React, { useState, useEffect } from "react";
import ChatSection from "./chatbox";

const HighlightableContent = ({
  text,
  isHighlighted,
  getIsHighlightedText,
  getUserMessage,
  allChatsHighlights,
  isChatLoadingHighlighted,
  setUserMessageHighlights
}) => {
  const [showChatModal, setShowChatModal] = useState(false);
  const [selectedText, setSelectedText] = useState("");

  useEffect(() => {
    handleTextHighlight();
  }, [text, isHighlighted]);

  const handleTextHighlight = () => {
    const highlightedText = window.getSelection()?.toString();
    if (highlightedText) {
      setSelectedText(highlightedText);
      setShowChatModal(true);
    }
  };

  return (
    <div>
      <div onMouseUp={handleTextHighlight}></div>

      {showChatModal && (
        <div
          className="modal"
          style={{
            display: "block",
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            zIndex: 999
          }}
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content" style={{ borderRadius: "15px" }}>
              <div className="modal-body">
                <button
                  type="button"
                  className="btn-close"
                  aria-label="Close"
                  style={{ position: "absolute", top: "10px", right: "10px" }}
                  onClick={() => {
                    getIsHighlightedText(false);
                    setShowChatModal(false);
                  }}
                ></button>
                <ChatSection
                  chats={[{ sender: "ai", message: selectedText }]}
                  allChatsHighligh={allChatsHighlights}
                  getUserMessage={getUserMessage}
                  setUserMessageHighlights={setUserMessageHighlights}
                />
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default HighlightableContent;
